export const DEFAULT_LOCALE = 'pt-BR'

const PERCENTUAL_MAXIMO = 100

const FORMATO_ACEITO = /^\d{0,3}([.,]\d{0,2})?$/

export const dentroDaFaixaPercentual = (texto: string): boolean => {
  if (texto === '') return true
  if (!FORMATO_ACEITO.test(texto)) return false
  return Number(texto.replace(',', '.')) <= PERCENTUAL_MAXIMO
}

export const formatarPercentual = (
  valor: number,
  locale: string = DEFAULT_LOCALE,
  exibirSufixo: boolean = true,
  minimumFractionDigits: number = 2,
  maximumFractionDigits: number = 2,
): string => {
  return (
    new Intl.NumberFormat(locale, { minimumFractionDigits, maximumFractionDigits }).format(valor) +
    (exibirSufixo ? '%' : '')
  )
}

export const textoParaPercentual = (texto: string): number | undefined => {
  const numero = Number(texto.replace(',', '.'))
  return texto === '' || Number.isNaN(numero) ? undefined : numero
}

export const percentualParaTexto = (percentual?: number | null, locale: string = DEFAULT_LOCALE): string =>
  percentual === null || percentual === undefined ? '' : formatarPercentual(percentual, locale, false)
